import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "card seq-card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-center" }
const _hoisted_4 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Profile Avatar", -1)
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "seq-profile-avatar px-2" }
const _hoisted_8 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_9 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "bi bi-x fs-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "seq-field-label mb-1" }, "Avatar"),
  /*#__PURE__*/_createVNode("p", { class: "seq-profile-hint mb-0" }, "Allowed file types: png, jpg, jpeg.")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "card seq-card mb-5 mb-xxl-8"
}
const _hoisted_15 = { class: "card-header border-0 pt-5" }
const _hoisted_16 = { class: "card-title align-items-center" }
const _hoisted_17 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "My Team", -1)
const _hoisted_19 = { class: "card-body py-3" }
const _hoisted_20 = { class: "seq-profile-form px-2" }
const _hoisted_21 = { class: "seq-profile-row" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Team Name", -1)
const _hoisted_23 = { class: "seq-profile-control" }
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { class: "seq-profile-row mb-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Team Avatar", -1)
const _hoisted_27 = { class: "seq-profile-control" }
const _hoisted_28 = { class: "seq-profile-avatar" }
const _hoisted_29 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_30 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  title: "Change team avatar"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_32 = { class: "seq-profile-row mb-2" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Team Cover Photo", -1)
const _hoisted_34 = { class: "seq-profile-control" }
const _hoisted_35 = {
  class: "seq-dashboard-profile__cover mb-3",
  style: {"max-width":"100%","border-radius":"8px","overflow":"hidden"}
}
const _hoisted_36 = { class: "btn btn-sm btn-light-primary mb-2" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Upload Team Cover ")
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "seq-profile-hint mb-1" }, "Allowed file types: png, jpg, jpeg. Max 1MB.", -1)
const _hoisted_39 = {
  key: 1,
  class: "seq-profile-hint mt-2 mb-0"
}
const _hoisted_40 = {
  key: 1,
  class: "card seq-card mb-5 mb-xxl-8"
}
const _hoisted_41 = { class: "card-header border-0 pt-5" }
const _hoisted_42 = { class: "card-title align-items-center" }
const _hoisted_43 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Cover Photo", -1)
const _hoisted_45 = { class: "card-body py-3" }
const _hoisted_46 = { class: "seq-profile-form px-2" }
const _hoisted_47 = {
  class: "seq-dashboard-profile__cover mb-4",
  style: {"max-width":"100%","border-radius":"8px","overflow":"hidden"}
}
const _hoisted_48 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label d-block mb-2" }, "Team affiliation", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("option", { value: 0 }, "Select a team", -1)
const _hoisted_51 = {
  key: 0,
  class: "seq-profile-hint mt-2 mb-0"
}
const _hoisted_52 = { class: "mb-3" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label d-block mb-2" }, "Cover source", -1)
const _hoisted_54 = { class: "form-check mb-2" }
const _hoisted_55 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "coverSourceTeam"
}, " Use team cover ", -1)
const _hoisted_56 = {
  key: 0,
  class: "seq-profile-hint mb-2"
}
const _hoisted_57 = {
  key: 1,
  class: "seq-profile-hint mb-2"
}
const _hoisted_58 = { class: "form-check mb-2" }
const _hoisted_59 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "coverSourceCustom"
}, " Use my own cover ", -1)
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "btn btn-sm btn-light-primary" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Upload Cover Photo ")
const _hoisted_63 = /*#__PURE__*/_createVNode("p", { class: "seq-profile-hint mt-2 mb-0" }, "Allowed file types: png, jpg, jpeg. Max 1MB.", -1)
const _hoisted_64 = { class: "card seq-card mb-5 mb-xxl-8" }
const _hoisted_65 = { class: "card-header border-0 pt-5" }
const _hoisted_66 = { class: "card-title align-items-center" }
const _hoisted_67 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Profile Details", -1)
const _hoisted_69 = { class: "card-body py-3" }
const _hoisted_70 = { class: "seq-profile-row" }
const _hoisted_71 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Full Name", -1)
const _hoisted_72 = { class: "seq-profile-control" }
const _hoisted_73 = { class: "row g-3" }
const _hoisted_74 = { class: "col-md-4" }
const _hoisted_75 = { class: "col-md-4" }
const _hoisted_76 = { class: "col-md-4" }
const _hoisted_77 = { class: "seq-profile-row" }
const _hoisted_78 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Gender", -1)
const _hoisted_79 = { class: "seq-profile-control" }
const _hoisted_80 = /*#__PURE__*/_createVNode("option", { value: "M" }, "Male", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("option", { value: "F" }, "Female", -1)
const _hoisted_82 = { class: "seq-profile-row" }
const _hoisted_83 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Birthday", -1)
const _hoisted_84 = { class: "seq-profile-control" }
const _hoisted_85 = { class: "seq-profile-row" }
const _hoisted_86 = {
  key: 0,
  class: "seq-field-label seq-profile-label"
}
const _hoisted_87 = {
  key: 1,
  class: "seq-field-label seq-profile-label"
}
const _hoisted_88 = { class: "seq-profile-control" }
const _hoisted_89 = { class: "seq-profile-row" }
const _hoisted_90 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Address", -1)
const _hoisted_91 = { class: "seq-profile-control" }
const _hoisted_92 = { class: "seq-profile-row" }
const _hoisted_93 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Country", -1)
const _hoisted_94 = { class: "seq-profile-control" }
const _hoisted_95 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Select Country", -1)
const _hoisted_96 = { class: "seq-profile-row" }
const _hoisted_97 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Region/State", -1)
const _hoisted_98 = { class: "seq-profile-control" }
const _hoisted_99 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Select Region/State", -1)
const _hoisted_100 = {
  key: 0,
  class: "seq-profile-row"
}
const _hoisted_101 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "City/LGA", -1)
const _hoisted_102 = {
  key: 0,
  class: "seq-profile-control"
}
const _hoisted_103 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Select City", -1)
const _hoisted_104 = {
  key: 1,
  class: "seq-profile-control"
}
const _hoisted_105 = { class: "seq-profile-row" }
const _hoisted_106 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Mobile Number", -1)
const _hoisted_107 = { class: "seq-profile-control" }
const _hoisted_108 = { class: "row g-3" }
const _hoisted_109 = { class: "col-md-6" }
const _hoisted_110 = { class: "seq-profile-row" }
const _hoisted_111 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Email Address", -1)
const _hoisted_112 = { class: "seq-profile-control" }
const _hoisted_113 = { class: "row g-3" }
const _hoisted_114 = { class: "col-md-6" }
const _hoisted_115 = {
  key: 1,
  class: "seq-profile-row"
}
const _hoisted_116 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Hide Network Activity", -1)
const _hoisted_117 = { class: "seq-profile-control d-flex align-items-center" }
const _hoisted_118 = { class: "form-check form-switch fv-row" }
const _hoisted_119 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "btnHideUnhideNetworkActivity"
}, null, -1)
const _hoisted_120 = { class: "seq-profile-actions" }
const _hoisted_121 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, "Save Changes", -1)
const _hoisted_122 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_123 = { class: "card seq-card mb-5 mb-xxl-8" }
const _hoisted_124 = { class: "card-header border-0 pt-5" }
const _hoisted_125 = { class: "card-title align-items-center" }
const _hoisted_126 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_127 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Change Password", -1)
const _hoisted_128 = { class: "card-body py-3" }
const _hoisted_129 = { class: "seq-profile-password d-flex flex-wrap align-items-start gap-4" }
const _hoisted_130 = /*#__PURE__*/_createVNode("p", { class: "seq-field-label mb-1" }, "Password", -1)
const _hoisted_131 = /*#__PURE__*/_createVNode("p", { class: "seq-profile-password-mask mb-0" }, "************", -1)
const _hoisted_132 = /*#__PURE__*/_createVNode("p", { class: "seq-profile-password-hint" }, "Password must be at least 8 characters and contains symbols", -1)
const _hoisted_133 = { class: "row g-3 mb-4" }
const _hoisted_134 = { class: "col-lg-4" }
const _hoisted_135 = /*#__PURE__*/_createVNode("label", {
  for: "currentpassword",
  class: "seq-field-label"
}, "Current Password", -1)
const _hoisted_136 = { class: "col-lg-4" }
const _hoisted_137 = /*#__PURE__*/_createVNode("label", {
  for: "newpassword",
  class: "seq-field-label"
}, "New Password", -1)
const _hoisted_138 = { class: "col-lg-4" }
const _hoisted_139 = /*#__PURE__*/_createVNode("label", {
  for: "confirmpassword",
  class: "seq-field-label"
}, "Confirm New Password", -1)
const _hoisted_140 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_141 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, "Update Password", -1)
const _hoisted_142 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_143 = {
  key: 2,
  class: "card seq-card mb-5 mb-xxl-8"
}
const _hoisted_144 = { class: "card-header border-0 pt-5" }
const _hoisted_145 = { class: "card-title align-items-center" }
const _hoisted_146 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_147 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Generate E-Cheque", -1)
const _hoisted_148 = { class: "card-body py-3 seq-profile-echeque" }
const _hoisted_149 = /*#__PURE__*/_createVNode("p", { class: "seq-profile-echeque-desc" }, "Please select the income range and click the button to generate your E-Cheque.", -1)
const _hoisted_150 = { class: "seq-period-filter mb-4" }
const _hoisted_151 = { class: "seq-period-filter__field seq-period-filter__field--month" }
const _hoisted_152 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "Income Range", -1)
const _hoisted_153 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Income This Week", -1)
const _hoisted_154 = /*#__PURE__*/_createVNode("option", { value: "1" }, "Income This Month", -1)
const _hoisted_155 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Income This Year", -1)
const _hoisted_156 = /*#__PURE__*/_createVNode("option", { value: "3" }, "Select Date Range", -1)
const _hoisted_157 = {
  key: 0,
  class: "seq-period-filter__field seq-period-filter__field--date"
}
const _hoisted_158 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "From Date", -1)
const _hoisted_159 = {
  key: 1,
  class: "seq-period-filter__field seq-period-filter__field--date"
}
const _hoisted_160 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "To Date", -1)
const _hoisted_161 = {
  key: 3,
  type: "button",
  class: "btn btn-seq-view",
  disabled: ""
}
const _hoisted_162 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_163 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Form = _resolveComponent("Form")
  const _component_Field = _resolveComponent("Field")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h3", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
            ]),
            _hoisted_5
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            id: "kt_account_avatar_form",
            class: "form",
            novalidate: "novalidate"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", {
                    class: "image-input-wrapper w-125px h-125px",
                    style: `background-image: url(${_ctx.avatarlink})`
                  }, null, 4),
                  _createVNode("label", _hoisted_9, [
                    _hoisted_10,
                    _createVNode("input", {
                      type: "file",
                      id: "avatar",
                      ref: "avatar",
                      accept: ".png, .jpg, .jpeg",
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleFileUpload()))
                    }, null, 544),
                    _hoisted_11
                  ]),
                  _createVNode("span", {
                    class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
                    "data-kt-image-input-action": "remove",
                    "data-bs-toggle": "tooltip",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeImage())),
                    title: "Remove avatar"
                  }, [
                    _hoisted_12
                  ])
                ]),
                _hoisted_13
              ])
            ]),
            _: 1
          })
        ])
      ]),
      (false && _ctx.isTeamLeader)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("h3", _hoisted_16, [
                _createVNode("span", _hoisted_17, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Shield-user.svg" })
                ]),
                _hoisted_18
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode("div", _hoisted_23, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "seq-profile-input",
                      placeholder: "Enter team name",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.teamName = $event)),
                      readonly: _ctx.isTeamLeader && !_ctx.editingTeamName
                    }, null, 8, ["readonly"]), [
                      [_vModelText, _ctx.teamName]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-light-primary me-2",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveTeamName && _ctx.saveTeamName(...args)))
                  }, " Save Team Name ")
                ]),
                _createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _createVNode("div", {
                          class: "image-input-wrapper w-125px h-125px",
                          style: `background-image: url(${_ctx.teamAvatarUrl || 'media/avatars/blank.png'})`
                        }, null, 4),
                        _createVNode("label", _hoisted_30, [
                          _hoisted_31,
                          _createVNode("input", {
                            type: "file",
                            accept: ".png, .jpg, .jpeg",
                            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleTeamAvatarUpload && _ctx.handleTeamAvatarUpload(...args)))
                          }, null, 32)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode("div", _hoisted_34, [
                    _createVNode("div", _hoisted_35, [
                      _createVNode("img", {
                        src: _ctx.teamCoverPreviewUrl,
                        alt: "Team cover preview",
                        class: "seq-dashboard-profile__cover-img",
                        style: {"height":"120px"}
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("label", _hoisted_36, [
                      _hoisted_37,
                      _createVNode("input", {
                        type: "file",
                        class: "d-none",
                        accept: ".png, .jpg, .jpeg",
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleTeamCoverUpload && _ctx.handleTeamCoverUpload(...args)))
                      }, null, 32)
                    ]),
                    _hoisted_38,
                    (_ctx.teamCoverStatus)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          class: ["badge", _ctx.teamCoverStatusBadgeClass]
                        }, _toDisplayString(_ctx.teamCoverStatusLabel), 3))
                      : _createCommentVNode("", true),
                    (_ctx.teamCoverStatus === 'pending')
                      ? (_openBlock(), _createBlock("p", _hoisted_39, " Your team cover is pending admin review. Downline members cannot use it until approved. "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (false && (_ctx.isTeamLeader || _ctx.hasAvailableUplineTeams))
        ? (_openBlock(), _createBlock("div", _hoisted_40, [
            _createVNode("div", _hoisted_41, [
              _createVNode("h3", _hoisted_42, [
                _createVNode("span", _hoisted_43, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                ]),
                _hoisted_44
              ])
            ]),
            _createVNode("div", _hoisted_45, [
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _createVNode("img", {
                    src: _ctx.coverPhotoUrl || 'media/cover/unstoppabull.png',
                    alt: "Profile cover",
                    class: "seq-dashboard-profile__cover-img",
                    style: {"height":"120px"}
                  }, null, 8, ["src"])
                ]),
                (!_ctx.isTeamLeader && _ctx.hasAvailableUplineTeams)
                  ? (_openBlock(), _createBlock("div", _hoisted_48, [
                      _hoisted_49,
                      _withDirectives(_createVNode("select", {
                        class: "seq-profile-select form-select",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedTeamId = $event)),
                        onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onMemberTeamChange && _ctx.onMemberTeamChange(...args)))
                      }, [
                        _hoisted_50,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableUplineTeams, (team) => {
                          return (_openBlock(), _createBlock("option", {
                            key: team.id,
                            value: team.id
                          }, _toDisplayString(team.teamName), 9, ["value"]))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.selectedTeamId]
                      ]),
                      (!_ctx.hasSelectedTeam)
                        ? (_openBlock(), _createBlock("p", _hoisted_51, " Choose an upline team to use its cover photo. "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode("div", _hoisted_54, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      id: "coverSourceTeam",
                      value: "team",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.coverSource = $event)),
                      disabled: !_ctx.teamCoverApproved,
                      onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onCoverSourceChange && _ctx.onCoverSourceChange(...args)))
                    }, null, 40, ["disabled"]), [
                      [_vModelRadio, _ctx.coverSource]
                    ]),
                    _hoisted_55
                  ]),
                  (!_ctx.isTeamLeader && !_ctx.hasSelectedTeam)
                    ? (_openBlock(), _createBlock("p", _hoisted_56, " Select an upline team above before using team cover. "))
                    : (!_ctx.teamCoverApproved)
                      ? (_openBlock(), _createBlock("p", _hoisted_57, " Team cover is pending admin review or not yet available. "))
                      : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_58, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      id: "coverSourceCustom",
                      value: "custom",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.coverSource = $event)),
                      onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onCoverSourceChange && _ctx.onCoverSourceChange(...args)))
                    }, null, 544), [
                      [_vModelRadio, _ctx.coverSource]
                    ]),
                    _hoisted_59
                  ])
                ]),
                (_ctx.coverSource === 'custom')
                  ? (_openBlock(), _createBlock("div", _hoisted_60, [
                      _createVNode("label", _hoisted_61, [
                        _hoisted_62,
                        _createVNode("input", {
                          type: "file",
                          class: "d-none",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleProfileCoverUpload && _ctx.handleProfileCoverUpload(...args)))
                        }, null, 32)
                      ]),
                      _hoisted_63
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_64, [
        _createVNode("div", _hoisted_65, [
          _createVNode("h3", _hoisted_66, [
            _createVNode("span", _hoisted_67, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Shield-user.svg" })
            ]),
            _hoisted_68
          ])
        ]),
        _createVNode("div", _hoisted_69, [
          _createVNode(_component_Form, {
            id: "kt_account_profile_details_form",
            class: "form seq-profile-form",
            novalidate: "novalidate"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_70, [
                _hoisted_71,
                _createVNode("div", _hoisted_72, [
                  _createVNode("div", _hoisted_73, [
                    _createVNode("div", _hoisted_74, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "fname",
                        class: "seq-profile-input",
                        placeholder: "First name",
                        modelValue: _ctx.fname,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.fname = $event)),
                        readonly: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_75, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "mname",
                        class: "seq-profile-input",
                        placeholder: "Middle name",
                        modelValue: _ctx.mname,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.mname = $event)),
                        readonly: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_76, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "lname",
                        class: "seq-profile-input",
                        placeholder: "Last name",
                        modelValue: _ctx.lname,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.lname = $event)),
                        readonly: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_77, [
                _hoisted_78,
                _createVNode("div", _hoisted_79, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "gender",
                    class: "seq-profile-select",
                    modelValue: _ctx.gender,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.gender = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_80,
                      _hoisted_81
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_82, [
                _hoisted_83,
                _createVNode("div", _hoisted_84, [
                  _createVNode(_component_Field, {
                    type: "tel",
                    name: "birthday",
                    class: "seq-profile-input",
                    placeholder: "Birthday",
                    modelValue: _ctx.birthday,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.birthday = $event)),
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_85, [
                (_ctx.ccode != 12)
                  ? (_openBlock(), _createBlock("label", _hoisted_86, "TIN/CNIC"))
                  : _createCommentVNode("", true),
                (_ctx.ccode == 12)
                  ? (_openBlock(), _createBlock("label", _hoisted_87, "KRA Number"))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_88, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "tin",
                    class: "seq-profile-input",
                    placeholder: "TIN / CNIC / KRA Number",
                    modelValue: _ctx.tin,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.tin = $event)),
                    readonly: _ctx.ccode == 12 ? false : (_ctx.tinValue != '' ? true : false),
                    maxlength: _ctx.ccode == 12 ? 11 : 50
                  }, null, 8, ["modelValue", "readonly", "maxlength"])
                ])
              ]),
              _createVNode("div", _hoisted_89, [
                _hoisted_90,
                _createVNode("div", _hoisted_91, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "address",
                    class: "seq-profile-input",
                    placeholder: "Address",
                    modelValue: _ctx.address,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.address = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_92, [
                _hoisted_93,
                _createVNode("div", _hoisted_94, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "country",
                    class: "seq-profile-select",
                    modelValue: _ctx.selected_country,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.selected_country = $event)),
                    onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.getRegionState(_ctx.selected_country)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_95,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (item, index) => {
                        return (_openBlock(), _createBlock("option", {
                          key: index,
                          value: item.country_id
                        }, _toDisplayString(item.name), 9, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_96, [
                _hoisted_97,
                _createVNode("div", _hoisted_98, [
                  _withDirectives(_createVNode("select", {
                    name: "zone",
                    id: "zone",
                    class: "seq-profile-select",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.selected_zone = $event)),
                    onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.checkIfNigeria($event)))
                  }, [
                    _hoisted_99,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.zones, (item, index) => {
                      return (_openBlock(), _createBlock("option", {
                        key: index,
                        value: item.zone_id
                      }, _toDisplayString(item.name), 9, ["value"]))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selected_zone]
                  ])
                ])
              ]),
              (_ctx.selected_country == 156)
                ? (_openBlock(), _createBlock("div", _hoisted_100, [
                    _hoisted_101,
                    (_ctx.loadingLGA == false)
                      ? (_openBlock(), _createBlock("div", _hoisted_102, [
                          _withDirectives(_createVNode("select", {
                            name: "city",
                            class: "seq-profile-select",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.selected_city = $event))
                          }, [
                            _hoisted_103,
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (item, index) => {
                              return (_openBlock(), _createBlock("option", {
                                key: index,
                                value: item.lganame
                              }, _toDisplayString(item.lganame), 9, ["value"]))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.selected_city]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loadingLGA == true)
                      ? (_openBlock(), _createBlock("div", _hoisted_104, [
                          _createVNode(_component_el_skeleton, {
                            rows: 0,
                            animated: ""
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_105, [
                _hoisted_106,
                _createVNode("div", _hoisted_107, [
                  _createVNode("div", _hoisted_108, [
                    _createVNode("div", _hoisted_109, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "mobile",
                        class: "seq-profile-input",
                        placeholder: "Mobile Number",
                        modelValue: _ctx.mobile,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.mobile = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_110, [
                _hoisted_111,
                _createVNode("div", _hoisted_112, [
                  _createVNode("div", _hoisted_113, [
                    _createVNode("div", _hoisted_114, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "email",
                        class: "seq-profile-input",
                        placeholder: "Email Address",
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.email = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              (_ctx.isBiboOnly == 'false')
                ? (_openBlock(), _createBlock("div", _hoisted_115, [
                    _hoisted_116,
                    _createVNode("div", _hoisted_117, [
                      _createVNode("div", _hoisted_118, [
                        _createVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: "btnHideUnhideNetworkActivity",
                          checked: _ctx.isHiddenNetworkActivity,
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.toggleHideNetworkActivity()))
                        }, null, 8, ["checked"]),
                        _hoisted_119
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_120, [
                _createVNode("button", {
                  type: "button",
                  id: "kt_account_profile_details_submit",
                  class: "btn btn-seq-green min-w-100px",
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.saveProfileDetails()))
                }, [
                  _hoisted_121,
                  _hoisted_122
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_123, [
        _createVNode("div", _hoisted_124, [
          _createVNode("h3", _hoisted_125, [
            _createVNode("span", _hoisted_126, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Settings-1.svg" })
            ]),
            _hoisted_127
          ])
        ]),
        _createVNode("div", _hoisted_128, [
          _createVNode("div", _hoisted_129, [
            _createVNode("div", {
              id: "kt_signin_password",
              class: ["seq-profile-password-display", { 'd-none': _ctx.passwordFormDisplay }]
            }, [
              _hoisted_130,
              _hoisted_131
            ], 2),
            _createVNode("div", {
              id: "kt_signin_password_edit",
              class: ["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }]
            }, [
              _hoisted_132,
              _createVNode(_component_Form, {
                id: "kt_signin_change_password",
                class: "form seq-profile-form",
                novalidate: "novalidate"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_133, [
                    _createVNode("div", _hoisted_134, [
                      _hoisted_135,
                      _createVNode(_component_Field, {
                        type: "password",
                        class: "seq-profile-input",
                        name: "currentpassword",
                        id: "currentpassword",
                        modelValue: _ctx.oldpass,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.oldpass = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_136, [
                      _hoisted_137,
                      _createVNode(_component_Field, {
                        type: "password",
                        class: "seq-profile-input",
                        name: "newpassword",
                        id: "newpassword",
                        modelValue: _ctx.newpass,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.newpass = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_138, [
                      _hoisted_139,
                      _createVNode(_component_Field, {
                        type: "password",
                        class: "seq-profile-input",
                        name: "confirmpassword",
                        id: "confirmpassword",
                        modelValue: _ctx.confirmpass,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.confirmpass = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_140, [
                    _createVNode("button", {
                      id: "kt_password_submit",
                      type: "button",
                      class: "btn btn-seq-green min-w-100px",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.changePassword()))
                    }, [
                      _hoisted_141,
                      _hoisted_142
                    ]),
                    _createVNode("button", {
                      id: "kt_password_cancel",
                      type: "button",
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                      class: "btn btn-seq-blue min-w-100px"
                    }, " Cancel ")
                  ])
                ]),
                _: 1
              })
            ], 2),
            _createVNode("div", {
              id: "kt_signin_password_button",
              class: ["ms-auto", { 'd-none': _ctx.passwordFormDisplay }]
            }, [
              _createVNode("button", {
                onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                class: "btn btn-seq-blue min-w-100px"
              }, " Reset Password ")
            ], 2)
          ])
        ])
      ]),
      (_ctx.showGenerateECheque && _ctx.isBiboOnly == 'false')
        ? (_openBlock(), _createBlock("div", _hoisted_143, [
            _createVNode("div", _hoisted_144, [
              _createVNode("h3", _hoisted_145, [
                _createVNode("span", _hoisted_146, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Money.svg" })
                ]),
                _hoisted_147
              ])
            ]),
            _createVNode("div", _hoisted_148, [
              _hoisted_149,
              _createVNode("div", _hoisted_150, [
                _createVNode("div", _hoisted_151, [
                  _hoisted_152,
                  _withDirectives(_createVNode("select", {
                    class: "seq-period-filter__select",
                    id: "destination",
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.genType = $event))
                  }, [
                    _hoisted_153,
                    _hoisted_154,
                    _hoisted_155,
                    _hoisted_156
                  ], 512), [
                    [_vModelSelect, _ctx.genType]
                  ])
                ]),
                (_ctx.genType == 3)
                  ? (_openBlock(), _createBlock("div", _hoisted_157, [
                      _hoisted_158,
                      _withDirectives(_createVNode("input", {
                        type: "date",
                        class: "seq-period-filter__input",
                        name: "from_date",
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.from_date = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.from_date]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.genType == 3)
                  ? (_openBlock(), _createBlock("div", _hoisted_159, [
                      _hoisted_160,
                      _withDirectives(_createVNode("input", {
                        type: "date",
                        class: "seq-period-filter__input",
                        name: "to_date",
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.to_date = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.to_date]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isgeneratingCheque)
                  ? (_openBlock(), _createBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-seq-view",
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.generateECheque()))
                    }, " Generate "))
                  : _createCommentVNode("", true),
                (_ctx.isgeneratingCheque)
                  ? (_openBlock(), _createBlock("button", _hoisted_161, [
                      _hoisted_162,
                      _hoisted_163
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode("button", {
                  type: "button",
                  class: "btn btn-seq-green",
                  onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.showEChequeImageToggle()))
                }, " Show E-Cheque Image ", 512), [
                  [_vShow, !_ctx.showEChequeImage]
                ]),
                _withDirectives(_createVNode("button", {
                  type: "button",
                  class: "btn btn-seq-blue",
                  onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.showEChequeImageToggle()))
                }, " Hide E-Cheque Image ", 512), [
                  [_vShow, _ctx.showEChequeImage]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}